import {
  GET_PARTNERS,
  UPDATE_PARTNER,
  GET_PARTNER_WITH_ID,
  CREATE_PARTNER,
  UPDATE_PARTNER_STATUS,
  GET_USERS_BY_PARTNERID,
  GET_USERS_BE_ADMIN_PARTNER,
  UPDATE_PARTNER_ADMIN,
  GET_PARTNERS_INVONTORY,
  GET_PARTNER_CATEGORIES,
} from './constants';
import {PayloadUpdate, PayloadCreate} from './interfaces';

export function getPartnersAction(payload: Record<string, any>) {
  return {
    type: GET_PARTNERS,
    payload,
  };
}

export function getUsersByPartnerIdAction(payload: Record<string, any>) {
  return {
    type: GET_USERS_BY_PARTNERID,
    payload,
  };
}

export function getUsersBeAdminPartnerAction(payload: Record<string, any>) {
  return {
    type: GET_USERS_BE_ADMIN_PARTNER,
    payload,
  };
}

export function getPartnerWithIdAction(payload: {id: number}) {
  return {
    type: GET_PARTNER_WITH_ID,
    payload,
  };
}

export function updatePartnerActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_PARTNER,
    payload,
  };
}

export function updatePartnerAdminActions(payload: PayloadUpdate) {
  return {
    type: UPDATE_PARTNER_ADMIN,
    payload,
  };
}

export function createPartnerActions(payload: PayloadCreate) {
  return {
    type: CREATE_PARTNER,
    payload,
  };
}

export function getPartnerCategoriesActions(payload: PayloadCreate) {
  return {
    type: GET_PARTNER_CATEGORIES,
    payload,
  };
}

export function updatePartnerStatusActions(payload: {
  id: number;
  body: string;
  pagination: object;
}) {
  return {
    type: UPDATE_PARTNER_STATUS,
    payload,
  };
}

export function getPartnersInventoryActions(payload: {id: number}) {
  return {
    type: GET_PARTNERS_INVONTORY,
    payload,
  };
}
